import React, { useState, useCallback } from 'react';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import Input from './Input';

const PasswordInput = (props) => {
  const [show, setShow] = useState(false);
  const handleClick = useCallback(() => setShow((state) => !state), []);

  return (
    <Input
      type={!show ? 'password' : 'text'}
      RightIcon={
        show ? (
          <Icon icon={ICONS.Eye} onClick={handleClick} className='eye-icon' disableCommonStyles />
        ) : (
          <Icon icon={ICONS.EyeCrossed} onClick={handleClick} className='eye-icon' disableCommonStyles />
        )
      }
      {...props}
    />
  );
};

export default PasswordInput;
